import React, { useContext } from 'react';
import Stars from 'atomic/utilization/stars';
import Link from 'atomic/utilization/link';
import flectionNumeral from 'helpers/number';
import opiBadge from 'assets/images/badge/opineo_badge.webp';
import Image from 'atomic/image';
import { TeApiContext } from '@ecommerce/nest-ssr/common';

import './product-opinion-summary.scss';

interface OpinionSummaryProps {
    title: string;
    url: string;
    count: number;
    average: number;
}

const ProductOpinionSummary: React.FC<OpinionSummaryProps> = ({ title, url, count, average }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className="opinion-summery">
            <div className="opinion-summery__stars-container">
                <div className="opinion-summery__stars-content">
                    <div className="opinion-summery__stars">
                        <Stars className="lg" width={average}/>
                        <span className="average">
                            {average.toFixed(1)}
                        </span>
                    </div>
                    <p className="opinion-summery__text">
                        {`na podstawie ${flectionNumeral(count, ['głosu klienta', 'głosów klientów', 'głosów klientów'])}`}
                    </p>
                </div>
                <div className="opinion-summery__stars-button">
                    { url && (
                        <Link
                            href={`${url?.replace('opinie', 'ocen')}?utm_source=skapiec&#zawartosc`}
                            target="_blank"
                            rel={`noopener noreferrer ${count === 0 ? 'nofollow' : ''}`}
                            className="opinion-summery__button"
                            type="button"
                            color="blue"
                            size="lg"
                            weight="600"
                            uppercase={true}
                        >
                            dodaj opinię
                        </Link>
                    )}
                </div>
            </div>
            {url && count > 0 && api.getDevice() !== 'mobile' && (
                <Link className="opinion-summery__badge" href={url} rel="noopener noreferrer"
                    target="_blank" title={title}
                >
                    <Image src={opiBadge} alt={title} show={true}
                        height={110} width={184} loading="lazy"
                    />
                </Link>
            )}
        </div>
    );
};

export default ProductOpinionSummary;
